import { WellDesignBase } from './base/well-design-base';

export class WellDesign extends WellDesignBase { }